import { laptopMediumMax, laptopMediumMin } from '@propertypal/shared/src/constants/mediaQueries';
import DistrictMap from '@propertypal/shared/src/resources/images/electoral-maps/ni-map.svg';
import { ElectoralDistrict } from '@propertypal/shared/src/types/electoral';
import { Container } from '@propertypal/web-ui/src/charts/LineChart.style';
import { MAX_WIDTH } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import styled, { css } from 'styled-components';

export const PriceTrackerContainer = styled.div`
  width: 100%;
  max-width: ${MAX_WIDTH - 40}px;
  padding: 0 10px;
  margin: 50px auto 80px;
`;

export const FormContainer = styled.div`
  margin-top: 50px;
  display: flex;
  gap: 30px;

  @media (${laptopMediumMax}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const MapContainer = styled.div<{ area: string }>`
  height: 100%;
  width: 100%;

  @media (${laptopMediumMin}) {
    display: flex;
    align-items: center;
    height: 500px;
    flex: 1;
  }

  .area-map {
    width: 100%;
    max-height: 500px;
  }

  ${({ area, theme }) =>
    area
      ? css`
          [data-id='${area}'] {
            fill: ${theme.primary};
            opacity: 1;
            path {
              fill: ${theme.primary};
              opacity: 1;
            }
          }

          [data-id='${area}_text'] {
            fill: ${theme.white};
            path {
              fill: ${theme.white};
            }
          }
        `
      : ''}
`;

export const NiMap = styled(DistrictMap)<{ district?: ElectoralDistrict['id'] }>`
  width: 100%;
  max-height: 500px;

  ${({ district, theme }) =>
    district
      ? css`
          [data-id='${district}'] {
            fill: ${theme.primary};
            opacity: 1;
            path {
              fill: ${theme.primary};
              opacity: 1;
            }
          }
        `
      : ''}

  /* Don't update colour for Belfast or ards & north down */
  ${({ district, theme }) =>
    !['N09000003', 'N09000011'].includes(district || '')
      ? css`
          [data-id='${district}_text'] {
            fill: ${theme.white};
            path {
              fill: ${theme.white};
            }
          }
        `
      : ''}

  @media (${laptopMediumMax}) {
    max-height: 400px;
  }
`;

export const ChartsContainer = styled.div`
  margin-top: 80px;
`;

export const LineChartContainer = styled.div`
  width: 100%;

  @media (${laptopMediumMin}) {
    margin-left: 20px;
    flex: 1;
  }
`;

export const LineChartHeader = styled.div<{ width: number }>`
  width: 100%;
  @media (${laptopMediumMin}) {
    width: ${({ width }) => width}px;
    margin-left: 20px;
  }
`;

export const LineChartWrapper = styled.div<{ hasGrowth?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;

  ${({ hasGrowth }) =>
    hasGrowth
      ? css`
          ${Container} {
            margin-top: 0px;
          }
        `
      : ''}

  @media (${laptopMediumMax}) {
    width: calc(100% - 10px);
    margin-left: 10px;
  }
`;
